import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBell,
    faUser,
    faRightFromBracket,
    faCircleQuestion,
    faIdBadge,
    faWallet,
    faQrcode,
    faUsers,
    faTableColumns,
    faUserGroup,
    faSquarePollVertical,
    faMoneyBill,
    faPeopleGroup,
    faAddressCard,
    faChevronDown,

} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";



import { faUser as faUserRegular } from "@fortawesome/free-regular-svg-icons";


import { useAuth } from "../context/AuthProvider";
import logo from "../assets/tiply_logo_v5.png";

export default function BusinessLayoutV2({ children }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const {
        currentUser,
        userData,
        venueOptions,
        activeVenue,
        clearVenueSelection,
        logout,
    } = useAuth();
    const navigate = useNavigate();



    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const handleChangeVenue = () => {
        setDropdownOpen(false);
        clearVenueSelection();
        navigate("/select-venue");
    };

    return (
        <div className="min-h-screen flex justify-center bg-[#f6f6f9] gap-x-48">
            {/* Sidebar */}
            <aside className="hidden lg:flex shrink-0 py-8 flex-col gap-6 ">
                {/*<h1 className="text-4xl font-extrabold text-green-500 tracking-wide">Tiply</h1>*/}
                <img src={logo} alt="Tiply" className="w-32 h-auto"/>
                {/*<img*/}
                {/*    src={logo}*/}
                {/*    alt="Logo"*/}
                {/*    className="h-14 w-auto mr-2"*/}
                {/*/>*/}
                <nav className="space-y-5 text-lg text-gray-700 mt-6 ml-2">
                    <SidebarItem icon={faTableColumns} label="Dashboard" onClick={() => navigate(`/business/dashboard`)}/>
                    <SidebarItem icon={faSquarePollVertical} label="Statistics" onClick={() => navigate(`/business/statistics`)}/>
                    <SidebarItem icon={faMoneyBill} label="Payouts" onClick={() => navigate(`/business/payouts`)}/>
                    <SidebarItem icon={faUserGroup} label="Employees" onClick={() => navigate(`/business/employees`)}/>
                    <SidebarItem icon={faAddressCard} label="Business info" onClick={() => navigate(`/business/information`)}/>
                </nav>
            </aside>

            {/* Main content wrapper */}
            <div className="flex flex-col w-full max-w-screen-md px-4 pb-8">

                {/* Main Content */}
                <main className="flex-1 w-full py-6">
                    <div className="max-w-5xl mx-auto flex justify-end items-center py-4 bg-[#f6f6f9]">
                        <div className="relative" ref={dropdownRef}>
                            <div
                                className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-full border border-gray-200 bg-white shadow-sm hover:bg-gray-50 transition"
                                onClick={() => setDropdownOpen((prev) => !prev)}
                            >
                                <span className="w-6 h-6 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center text-xs">
                                    <FontAwesomeIcon icon={faUserRegular} />
                                </span>
                                <span className="text-sm font-semibold text-gray-800">{userData?.firstName + " " + userData?.lastName || "Your Name"}</span>
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className={`text-xs text-gray-500 transition-transform ${dropdownOpen ? "rotate-180" : ""}`}
                                />
                            </div>

                            {dropdownOpen && (
                                <div className="absolute right-0 top-12 w-72 bg-white border border-gray-200 shadow-xl rounded-xl p-3 text-sm z-20">
                                    <div className="px-2 py-1.5 mb-2">
                                        <p className="font-semibold text-gray-900">{userData?.firstName + " " + userData?.lastName || "Your Name"}</p>
                                        <p className="text-xs text-gray-500 mt-0.5">
                                            {activeVenue?.businessName || "Business account"}
                                        </p>
                                    </div>
                                    <div className="space-y-1.5">
                                        {/*<DropdownItem icon={faIdBadge} text="Your details" />*/}
                                        {/*<DropdownItem icon={faCircleQuestion} text="Help" />*/}
                                        {venueOptions.length > 1 && (
                                            <button
                                                onClick={handleChangeVenue}
                                                className="flex items-center gap-2 text-gray-700 hover:bg-gray-50 w-full rounded-lg px-3 py-2 transition"
                                            >
                                                <span className="w-5 h-5 rounded-md bg-gray-100 flex items-center justify-center text-xs">
                                                    <FontAwesomeIcon icon={faTableColumns} />
                                                </span>
                                                <span>Change venue</span>
                                            </button>
                                        )}
                                        <button
                                            onClick={logout}
                                            className="flex items-center gap-2 text-red-600 hover:bg-red-50 w-full rounded-lg px-3 py-2 transition"
                                        >
                                            <span className="w-5 h-5 rounded-md bg-red-100 flex items-center justify-center text-xs">
                                                <FontAwesomeIcon icon={faRightFromBracket} />
                                            </span>
                                            <span>Log out</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {children}
                </main>

                {/* Bottom Nav */}
                <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around py-6 z-30 shadow-sm">
                    <BottomNavItem icon={faIdBadge} label="Dashboard" onClick={() => navigate(`/business/dashboard`)}/>
                    <BottomNavItem icon={faSquarePollVertical} label="Statistics" onClick={() => navigate(`/business/statistics`)}/>
                    <BottomNavItem icon={faMoneyBill} label="Payouts" onClick={() => navigate(`/business/payouts`)}/>
                    <BottomNavItem icon={faUserGroup} label="Employees" onClick={() => navigate(`/business/employees`)}/>
                    <BottomNavItem icon={faAddressCard} label="Info" onClick={() => navigate(`/business/information`)}/>
                </nav>
            </div>
        </div>

    );
}

// Sidebar Item
const SidebarItem = ({ icon, label, onClick }) => (
    <div
        className="flex items-center gap-3 text-gray-700 hover:text-black cursor-pointer transition-colors"
        onClick={onClick}
    >
        <FontAwesomeIcon icon={icon} className="w-5 text-center" />
        <span>{label}</span>
    </div>
);



// Bottom Navigation Button
const BottomNavItem = ({ icon, label, onClick }) => (
    <button className="flex flex-col items-center text-xs text-gray-700 hover:text-black" onClick={onClick}>
        <FontAwesomeIcon icon={icon} className="text-lg mb-1" />
        {label}
    </button>
);

// Dropdown menu item
const DropdownItem = ({ icon, text }) => (
    <div className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">
        <FontAwesomeIcon icon={icon} />
        <span>{text}</span>
    </div>
);
